export default "__VITE_ASSET__BFZBv8KB__"